// Quick-select reprint reasons — ONE TAP on a gloved tablet, never free-typing.
// Free text is optional and only unlocked behind "Other".
export const REPRINT_REASONS = [
  { code: "damaged_label", label: "Damaged label" },
  { code: "lost_missing", label: "Lost / missing" },
  { code: "wrong_media", label: "Wrong media for the part" },
  { code: "batch_recovery", label: "Batch recovery" },
  { code: "other", label: "Other" },
];

export const reasonLabel = (code) =>
  (REPRINT_REASONS.find((r) => r.code === code) || {}).label || code;
